<script>
/**
 * Preloader component
 */
export default {
  data() {
    return {
      id: 'loader' + this._uid,
      localLoading: false
    };
  },
  props: {
    loading: Boolean,
  },
  mounted() {
    this.localLoading = this.loading;
    this.showHideLoading();
  },
  watch: {
    loading: function (newVal) {
      this.localLoading = newVal;
      this.showHideLoading()
    }
  },
  methods: {
    showHideLoading() {
      const elem = document.getElementById(this.id);

      if (this.localLoading) {
        elem.style.display = "block";
        return;
      }

      elem.style.display = "none";
    }
  }
};
</script>

<template>
  <div :class="{ 'is-loading': localLoading }">
    <div :id="id" class="preloader-component">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <slot/>
  </div>
</template>

<style scoped>
.is-loading {
  position: relative;
}

.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}

.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>